<template>
  <keep-alive :include="['Product', 'BrandDetail']">
    <router-view :key="$route.fullPath" />
  </keep-alive>
</template>

<script>
const initIMP = () => {
  const IMP = window.IMP
  IMP.init('imp10362057')
}

export default {
  name: 'App',
  created () {
    initIMP()
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue